module.exports = __webpack_public_path__ + "static/media/destination_venice.cdbc3dee.jpg";